import React from "react";
import { styled, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

const ImagesTableRow = ({
  image,
}) => {
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`${image.imageEntityId}`);
  };

  const alternateText = "Not Specified";

  return (
    <StyledTableRow onClick={handleRowClick}>
      <TableCell component="th" scope="row">
        {image.imageName || alternateText}
      </TableCell>
      <TableCell align="right">{image.imageLabel || alternateText}</TableCell>
      <TableCell align="right">{image.imageCredit || alternateText}</TableCell>
      <TableCell align="right">{image.imageType || alternateText}</TableCell>
    </StyledTableRow>
  );
};

export default ImagesTableRow;